
import { Component, Inject } from '@angular/core';
import { AtpAddEditDynamicTableFullCrud } from 'src/app/atp-core/atp-dynamic-table-full-crud/atp-dynamic-form/atp-add-edit-dynamic-table-full-crud';
import { HttpService } from 'src/app/services/http.service';
import { HttpErrorsService } from 'src/app/services/http-errors.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ATP_DIALOG_DATA } from 'src/app/atp-core/components/atp-dialog/atp-dialog.service';
import { AtpAddEditData, IAtpAddEditInfo, AtpDynamicTableFullCrud } from 'src/app/atp-core/atp-core';
import { AtpDialogRef } from 'src/app/atp-core/components/atp-dialog/atp-dialog-container.component';
import { atpAnimations } from 'src/app/atp-core/atp-animations';

@Component({
  selector: 'add-edit-roles',
  templateUrl: '../../atp-dynamic-table-full-crud/atp-dynamic-form/atp-dynamic-form.component.html',
  styles: [
    `
    :host {
      display: block;
      position: relative;
      height: 100%;
    }
    `
  ],
  animations: [
    atpAnimations.OpenClose
  ]
})
export class AtpSettingsComponent extends AtpAddEditDynamicTableFullCrud<AtpSettingsComponent> {
  constructor(api: HttpService, httpErrors: HttpErrorsService, dialog: MatDialog, router: Router, @Inject(ATP_DIALOG_DATA) data: AtpAddEditData<any, IAtpAddEditInfo>, dialogRef?: AtpDialogRef<AtpSettingsComponent>) {
    super(api, httpErrors, dialog, router, data, dialogRef);
  }
}
